import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { selectCurrentOrgId } from "features/store/orgSlice"
import { TitleWithRef } from "widgets/common/PageTitle"
import AuditTrailTable from "widgets/organization/auditTrail/AuditTrailTable"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

const AuditTrail = () => {
  const { t } = useTranslation()
  const currentOrgId = useSelector(selectCurrentOrgId)
  // A page change brings the title back into view, and the date picker under it.
  const titleRef = useRef<HTMLDivElement>(null)

  useDocumentTitle(t("pageTitles.AUDIT_TRAIL"))

  return (
    <>
      <TitleWithRef text={t("pageTitles.AUDIT_TRAIL")} ref={titleRef} />
      <AuditTrailTable key={currentOrgId} scrollAnchorRef={titleRef} />
    </>
  )
}

export default AuditTrail
